// @ts-nocheck
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { Button, Drawer } from 'antd';
import { changeLogsDetails, clearLogs, getOperationLogs } from '../../../redux/actions/logs';
import { logsDateAndTimeFormat, PAGINATION_KEYS } from '../../../utils/constants';
import { DownloadOutlined } from '@ant-design/icons';
import { exportFile, generateFileExtension } from '../../../utils/export';
import { ONLINE_REPORT_SERVICE_API_ENDPOINT } from '../../../config';
import SharedTable from '../Table/Table';
import { setPagination } from '../../../redux/actions/pagination';

const OperationLogs = ({ columns, expandable, query, exportedFileName, exportable = true }) => {
    const dispatch = useDispatch();

    const { operationLogsDrawerVisibility, operationLogs, fetchData, logsDetails } = useSelector(state => state.logs);

    const paginationProps = useSelector(state => state.pagination[PAGINATION_KEYS.operationLogs]);
    const { page, limit, hasMore, isFetching } = paginationProps || {};

    const logs = useMemo(() => {
        return operationLogs.map(log => ({ ...log, ...log.operationLog }));
    }, [operationLogs]);

    const tableColumns = [
        {
            key: 'executedBy',
            title: 'Executed By',
            dataIndex: 'executedBy',
        },
        {
            key: 'commentByUser',
            title: 'Comment',
            dataIndex: 'commentByUser',
        },
        {
            key: 'executionDate',
            title: 'Execution Date',
            render: record => moment(record.executionDate).format(logsDateAndTimeFormat),
        },
        {
            key: 'operationType',
            title: 'Operation Type',
            dataIndex: 'operationType',
            sorter: (a, b) => a.operationType?.localeCompare(b.operationType),
        },
        ...columns,
    ];

    const onCloseClick = () => {
        dispatch(changeLogsDetails({ operationLogsDrawerVisibility: false }));
        dispatch(clearLogs());
        dispatch(
            setPagination(PAGINATION_KEYS.operationLogs, {
                offset: 0,
            }),
        );
    };

    const onLoadMoreClick = () => {
        dispatch(
            setPagination(PAGINATION_KEYS.operationLogs, {
                offset: page + limit,
            }),
        );
        dispatch(
            getOperationLogs({
                fetchData,
                query: {
                    operation: logsDetails.operation,
                    offset: page + limit,
                    limit,
                },
            }),
        );
    };

    const handleExportFile = exportType => {
        let fileName = generateFileExtension(exportedFileName, exportType);

        exportFile({
            requestUrl: `${ONLINE_REPORT_SERVICE_API_ENDPOINT}/operation/logs/download`,
            fileName,
            params: query,
        });
    };

    return (
        <Drawer
            title={
                <div className={`flex align-center justify-between m-r-10`}>
                    <span className={`font-weight-600`}>Logs</span>
                    {exportable && (
                        <Button
                            size={'small'}
                            type={'primary'}
                            onClick={() => handleExportFile('MS:EXCEL')}
                            disabled={!logs?.length}
                            icon={<DownloadOutlined style={{ fontSize: '1.5rem' }} />}
                        />
                    )}
                </div>
            }
            placement='right'
            closable={true}
            destroyOnClose
            onClose={onCloseClick}
            visible={operationLogsDrawerVisibility}
            width={'70%'}
        >
            <SharedTable
                rowKey={record => record.id}
                data={logs}
                loading={isFetching}
                columns={tableColumns}
                expandable={expandable}
            />
            {hasMore ? (
                <div className={'flex justify-center m-t-4'}>
                    <Button type={'primary'} onClick={onLoadMoreClick}>
                        Load More
                    </Button>
                </div>
            ) : null}
        </Drawer>
    );
};

export default OperationLogs;
